import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Http } from '@angular/http';

@Component({
    moduleId: module.id,
    selector: 'embedded-video',
    templateUrl: 'embedded-video.html'
})
export class EmbeddedVideoComponent implements OnChanges {

    @Input() url: string = "";
    @Input() width: string = "100%";
    @Input() height: string = "100%";
    @Input() allowPlay: boolean = true;
    playerUrl: SafeResourceUrl;
    externalPlayer: boolean = false;
    videoLoaded: boolean = false;

    constructor(private sanitizer: DomSanitizer, private http: Http) {
        this.playerUrl = this.safeUrl("");
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes["url"]) {
            this.playerUrl = this.safeUrl("");
            this.videoLoaded = false;
            if (!this.url || this.url.trim() == "") return;

            this.externalPlayer = true;
            let split = this.url.split("/");
            let videoId = "";

            if (this.url.toLowerCase().indexOf("://vimeo.com/") > -1
                || this.url.toLowerCase().indexOf("://player.vimeo.com/video/") > -1) {
                videoId = split[split.length - 1];

                if (this.allowPlay) this.playerUrl = this.safeUrl("https://player.vimeo.com/video/" + videoId);
                else {
                    let imgUrl = "http://vimeo.com/api/v2/video/" + videoId + ".json";
                    this.http.get(imgUrl).subscribe(r => this.playerUrl = this.safeUrl(r.json()[0].thumbnail_large));
                }

                this.videoLoaded = true;
                return;
            }

            if (this.url.toLowerCase().indexOf("://youtu.be/") > -1
                || this.url.toLowerCase().indexOf("://www.youtube.com/embed/") > -1) {
                videoId = split[split.length - 1];

                if (this.allowPlay) this.playerUrl = this.safeUrl("https://www.youtube.com/embed/" + videoId + '?rel=0');
                else this.playerUrl = this.safeUrl("https:/img.youtube.com/vi/" + videoId + "/0.jpg");

                this.videoLoaded = true;
                return;
            }

            if (this.url.toLowerCase().indexOf("://www.youtube.com/watch?v") > -1) {
                split = this.url.split("=");
                videoId = split[split.length - 1];

                if (this.allowPlay) this.playerUrl = this.safeUrl("https://www.youtube.com/embed/" + videoId + '?rel=0');
                else this.playerUrl = this.safeUrl("https:/img.youtube.com/vi/" + videoId + "/0.jpg");

                this.videoLoaded = true;
                return;
            }

            this.externalPlayer = false;
            this.playerUrl = this.safeUrl(this.url);
            this.videoLoaded = true;
        }
    }

    safeUrl(url: string) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/embedded-video/embedded-video.component.ts